/* eslint-disable no-extend-native */
import React, {useState, useContext} from 'react';
import {Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Grid, Backdrop, CircularProgress, DialogContentText, Alert, AlertTitle, TableCell, TableRow} from '@mui/material';
import { API } from '../conf';
import { TokenContext } from '../App';


export default function CongeRow(props) {
    const conge  = props.conge
    const [sending, setSend] = useState(false)
    const [show, setShow] = useState(false)
    const [deleting, setDelete] = useState(false)
    const [date_debut , setDebut] = useState('')
    const [date_fin , setFin] = useState('')
    const [nbre_jours, setNbre] = useState(props.conge.nbre_jours)
    const [msg, setMsg] = useState()
    const [token, setToken] = useContext(TokenContext)
    const [usr_total_jours, set_usr_total] = useState(0)

    const rm_token =()=>{
        setToken()
        return []
    }

    Array.prototype.sum = function (key) {
        return this.reduce((a, b) => a + (b[key] || 0), 0);
    }

    const get_usr_conges = async() => {
        setSend(true)
        fetch(API.concat(`/conges/utilisateurs/${conge.utilisateur._id}`),{
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        })
        .then(response => response.status === 200 ? response.json() : null)
        .then(result => {
            if (result !== null) {
                set_usr_total(result.sum("nbre_jours"))
            } else {
                set_usr_total(0)
            }
            setSend(false)
        })        
    }

    function get_sundays(date_debut, date_fin) { return new Promise((resolve, reject) => {
        var start = new Date(date_debut);
        var finish = new Date(date_fin);
        var dayMilliseconds = 1000 * 60 * 60 * 24;
        var weekendDays = 0;
    
        while (start <= finish) {
            var day = start.getDay()
            if (day === 6) {
                weekendDays++;
            }
            start = new Date(+start + dayMilliseconds);
        }  
        resolve(weekendDays)
    })}

    function update() {
        if(date_debut&& date_fin){
            setSend(true)
            setMsg()
            fetch(API.concat(`/conge/${conge._id}/update`), {
                method: 'PUT',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token
                },
                body: JSON.stringify({
                    date_debut: date_debut,
                    date_fin: date_fin,
                    status: 'validé'
                })
            })
            .then(response=> {
                if(response.status === 200){
                    let new_conge = props.conge; new_conge.date_debut=date_debut.concat('T00:00:00.000Z'); new_conge.date_fin=date_fin.concat('T00:00:00.000Z'); new_conge.nbre_jours=nbre_jours
                    props.update_data[0](conge, new_conge)
                    setShow(false)
                } else if(response.status === 401) {rm_token()} 
                else setMsg({severity: 'Error',
                title: 'Erreur',
                text: 'Une erreur est survenue, veuillez réessayer ultérieurement'})
                
                setSend(false)
            })
        } else setMsg({severity: 'warning',
        title:'Attention!',
        text: 'Vous devez remplir tous les champs obligatoires'})
    }

    function handleDeleteSubmit() {
        setSend(true)
        fetch(API.concat(`/conge/${conge._id}`), {
            method: 'DELETE',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        })
        .then(response=> {
            if(response.status === 200){
                props.update_data[1](conge._id)
                // setData(old => old.filter(row => row._id !== deleting))
            } else if(response.status === 401) rm_token()
            setDebut(''); setFin(''); setDelete(false);
            setSend(false)
        })
    }

    return(
        <>
            <TableRow
            key={conge._id}
            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
                <TableCell align="center"><span style={{textTransform: 'capitalize'}}>{conge.utilisateur.nom_complet}</span></TableCell>
                <TableCell align="center"><span style={{textTransform: 'capitalize'}}>{conge.utilisateur.departement}</span></TableCell>
                <TableCell align="center"><span style={{textTransform: 'capitalize'}}>{new Date(conge.date_debut.slice(0, -5)).toLocaleDateString()}</span></TableCell>
                <TableCell align="center"><span style={{textTransform: 'capitalize'}}>{new Date(conge.date_fin.slice(0, -5)).toLocaleDateString()}</span></TableCell>
                <TableCell align="center"><span style={{textTransform: 'capitalize'}}>{conge.nbre_jours}</span></TableCell>
                <TableCell align="center">
                    <Button variant='text' style={{color:'turquoise', textDecorationLine:'underline', textTransform:'none', height: 18}}
                    onClick={()=>{
                        get_usr_conges(); setShow(true); setNbre(conge.nbre_jours)
                        setDebut(new Date(conge.date_debut.slice(0, -5)).toISOString().split("T")[0]); 
                        setFin(new Date(conge.date_fin.slice(0, -5)).toISOString().split("T")[0])
                        setMsg()
                    }}>Modifier</Button>
                    <Button variant='text' style={{color:'coral', textDecorationLine:'underline', textTransform:'none', height: 18}}
                    onClick={()=> {setDelete(conge._id)}}>Supprimer</Button>
                </TableCell>
            </TableRow>
            
            {/*update dialog form */}
            <Dialog open={show} onClose={()=> setShow(false)} sx={{borderRadius:5}} >
                <DialogTitle sx={{textAlign: 'center', fontWeight: 'bold'}}>Modifier un congé</DialogTitle>
                <DialogContent>
                {msg && <Alert severity={msg.severity}>
                    <AlertTitle>{msg.title}</AlertTitle>
                    {msg.text}
                </Alert>}
                <div style={{display:'flex', alignItems:'center', flexDirection:'column'}}>
                <div>
                    <DialogContentText style={{margin:'10px 0px'}}><span style={{color: '#000', fontSize:17}}>Employé: {conge.utilisateur.nom_complet}</span></DialogContentText>
                    <DialogContentText style={{margin:'5px 0px'}}><span style={{color: 'coral', fontSize:15}}>Cet employé dispose actuellement de {30 - usr_total_jours} jours de congé</span></DialogContentText>
                    <Grid container spacing={{xs: 3, md: 5}}>
                        <Grid item>
                            <TextField
                            margin="normal"
                            required
                            InputLabelProps={{shrink: true}}
                            label="Date de début"
                            type='date'
                            inputProps={{min: new Date(`01-01-${new Date().getFullYear()}`).toISOString().split("T")[0], max: new Date(`04-30-${new Date().getFullYear()+1}`).toISOString().split("T")[0]}}
                            value={date_debut}
                            onChange={(event)=> {
                                setDebut(event.target.value)
                                if (date_fin) {
                                    get_sundays(event.target.value, date_fin)
                                    .then(async(sundays)=>{
                                        const nbre_days = Math.round((new Date(date_fin).getTime() - new Date(event.target.value).getTime()) / (1000 * 60 * 60 * 24)) + 1 - sundays
                                        setNbre(nbre_days>0 ? nbre_days : 0)
                                        if (nbre_days < 1) {
                                           setFin('')
                                        } else if (usr_total_jours - conge.nbre_jours + nbre_days > 30) {
                                            setMsg({
                                                severity:'warning',
                                                title:"Attention, nombre de jours trop élevé",
                                                text: `Si vous enregistrez ce congé, ${conge.utilisateur.nom_complet} cumulera ${usr_total_jours - conge.nbre_jours + nbre_days} jours de congé dépassant ainsi la limite des 30 jours`
                                            })
                                        } else setMsg()
                                    })
                                }
                            }}
                            />
                        </Grid>
                        <Grid item>
                            <TextField
                            margin="normal"
                            required
                            InputLabelProps={{shrink: true}}
                            disabled={date_debut.length === 0}
                            label="Date de fin"
                            type="date"
                            inputProps={{min: date_debut ? new Date(date_debut).toISOString().split("T")[0]: "", max: date_debut ? new Date(new Date(date_debut).getTime()+(1000 * 60 * 60 * 24 * 35)).toISOString().split("T")[0] : ""}}
                            min={date_debut ? new Date(date_debut).toISOString().split("T")[0]: ""}
                            value={date_fin}
                            onChange={(event)=> {
                                setFin(event.target.value)
                                get_sundays(date_debut, event.target.value)
                                .then(async(sundays)=>{
                                    const nbre_days = Math.round((new Date(event.target.value).getTime() - new Date(date_debut).getTime()) / (1000 * 60 * 60 * 24)) + 1 - sundays
                                    setNbre(nbre_days)
                                    if (usr_total_jours - conge.nbre_jours + nbre_days > 30) {
                                        setMsg({
                                            severity:'warning',
                                            title:"Attention, nombre de jours trop élevé",
                                            text: `Si vous enregistrez ce congé, ${conge.utilisateur.nom_complet} cumulera ${usr_total_jours - conge.nbre_jours + nbre_days} jours de congé dépassant ainsi la limite des 30 jours`
                                        })
                                    } else setMsg()
                                })
                            }}
                            />
                        </Grid>
                    </Grid>
                    <TextField
                    margin="normal"
                    style={{minWidth:130}}
                    required
                    InputLabelProps={{shrink: true}}
                    disabled={date_debut.length === 0 || date_fin.length === 0}
                    label="Nombre de jours"
                    type="number"
                    inputProps={{min:1, max:30, onKeyDown: (event) => {
                        event.preventDefault();
                     }, }}
                    min={1}
                    value={nbre_jours}
                    onChange={(event)=> setNbre(Number(event.target.value))}
                    />
                </div>
                </div>
                </DialogContent>
                <DialogActions sx={{justifyContent:'center', marginBottom: 2}}>
                    <Button variant='contained' color='grey' onClick={()=> setShow(false)}><span style={{ fontWeight:'bold'}}>Annuler</span></Button>
                    <Button variant='contained' color='valide' 
                    disabled={sending ||!date_debut||!date_fin}
                    onClick={() => update()}>
                        <span style={{color:'#000', fontWeight:'bold'}}>Enregistrer</span>
                    </Button>
                </DialogActions>
                <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={sending && !deleting}
                >
                    <CircularProgress color="valide" />
                </Backdrop>
            </Dialog>
            
            {/* delete dialog */}
            <Dialog open={deleting} onClose={()=> {setDelete(false)}} sx={{borderRadius:5}} >
                <DialogTitle sx={{textAlign: 'center'}}><span style={{color: 'coral', fontStyle:'italic', fontWeight: 'bold'}}>Supprimer </span>les congés du {new Date(conge.date_debut.slice(0, -5)).toLocaleDateString()} au {new Date(conge.date_fin.slice(0, -5)).toLocaleDateString()} de {conge.utilisateur.nom_complet}</DialogTitle>
                <DialogContent>
                    <DialogContentText><span style={{color: '#EF7070', fontSize:13}}>{msg}</span></DialogContentText>
                    <DialogContentText sx={{textAlign: 'center'}}><span style={{ color:'#000'}}>Cette opération est irréversible.<br/> Êtes-vous sûr de vouloir continuer ?</span></DialogContentText>
                </DialogContent>
                <DialogActions sx={{justifyContent:'center', marginBottom: 2}}>
                    <Button variant='contained' color='grey' onClick={()=> {setDelete(false)}}><span style={{ fontWeight:'bold'}}>Annuler</span></Button>
                    <Button variant='contained' color='coral' 
                    onClick={handleDeleteSubmit}><span style={{color:'#000', fontWeight:'bold'}}>Supprimer</span></Button>
                </DialogActions>
                <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={sending && deleting}
                >
                    <CircularProgress color="coral" />
                </Backdrop>
            </Dialog>
            <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={sending && !deleting && !show}
            >
                <CircularProgress color="valide" />
            </Backdrop>
        </>
    )
}